import { Node_Type } from 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const linkPreviewConverter = {
  toTiptap: {
    types: [Node_Type.LINK_PREVIEW],
    convert: (node) => ({
      type: Node_Type.LINK_PREVIEW,
      attrs: __spreadProps(__spreadValues({}, node.linkPreviewData), {
        id: node.id
      })
    })
  },
  fromTiptap: {
    types: [Node_Type.LINK_PREVIEW],
    convert: (node) => {
      const _a = node.attrs || {}, { id } = _a, data = __objRest(_a, ["id"]);
      return {
        type: Node_Type.LINK_PREVIEW,
        id,
        nodes: [],
        linkPreviewData: __spreadValues({}, data)
      };
    }
  }
};

export { linkPreviewConverter };
//# sourceMappingURL=link-preview-converter.js.map
